import { SVG } from "apparatus/svg";
export class Goggles {
    render(appearance) {
        let graphic = SVG.goggles();
        graphic.scale(1.8 * appearance.scale);
        return { graphic: graphic, hitShape: graphic.bounds.toShape() };
    }
}
Goggles.properties = {
    label: "Goggles",
    defaultAppearance: {
        scale: 1.0
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "scale", label: "Scale",
            min: 0.5, max: 3, step: 0.1
        }
    ],
};
